<template>
  <div id="rightThree" style=" height: 100%; margin-top: 10px;">
    <div id="rightThreeContent" style="margin-left: -8%; height: 270px; width: 110%; overflow: scroll; border-radius: 10px; ">
      <!--:header-cell-style="{background:'#1a2968',color:white, fontsize:8,fontFamily: 新宋体}"-->
      <!--<el-button @click="fun">测试</el-button>-->
      <el-table :data="tableData"
                style="width: 100%; min-height: 340px; background-color: #20337f; " :show-header="showHeader"
                :row-class-name="tabRowClassName">
        <el-table-column show-overflow-tooltip
          prop="a"
          label=""
          width="60">
        </el-table-column>
<!--        <el-table-column show-overflow-tooltip-->
<!--          prop="b"-->
<!--          label=""-->
<!--          width="40">-->
<!--        </el-table-column>-->
        <el-table-column show-overflow-tooltip prop="f" label="" width="36"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="c"
          label=""
          width="130">
        </el-table-column>
        <el-table-column show-overflow-tooltip
          prop="d"
          label=""
          width="125">
        </el-table-column>
        <el-table-column show-overflow-tooltip
          prop="e"
          label=""
          width="auto">
          <template slot-scope="scope">
            <a :href="'/#/realTimeData?alarmPointId='+scope.row.e" target="_blank" style=" color: white">详情</a>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeRightTwo2',
  data(){
    return {
      formerTableData:[], // 上一次的数据
      isLoading: true,
      ScrollDevScreen:{
        "version": 1,
        "method": "synthScreen.ScrollDevScreen",
        "params": {
          "areaId":"0",
        },
        "token": "",
        "id": 0
      },
      showHeader: false,
      count: 20,
      msg:[],
      tableData: [],
      interval:"",
    }
  },
  methods:{
    getTypeCN(type){
      let res = "";
      switch (type) {
        case 'alarm':
          res = '告警';
          break;
        case 'login':
          res = "登录";
          break;
      }
      return res;
    },
    getScrollDevScreen(init){
      if(init){
        this.isLoading = true;
      }
      this.ScrollDevScreen.token = this.$store.state.token;
      console.log('获取提醒');
      console.log(this.ScrollDevScreen);
      this.$axios.post(this.$mainUrl, this.ScrollDevScreen).then(res=> {
        this.formerTableData = JSON.parse(JSON.stringify(this.tableData));
        this.isLoading = false;
        console.log('获取提醒请求得到响应');
        console.log(res.data);
        res.data.result.devInformationLists.reverse();
        if(res.data.hasOwnProperty('result')){
          this.tableData = [];
          res.data.result.devInformationLists.forEach(item =>{
            let t = {};
            t.a = item.pointName;
            t.b = this.getTypeCN(item.type);
            t.c = item.alarmType;
            t.d = item.alarmTime;
            t.e = item.alarmPointId;
            t.f = item.alarmCount;
            t._id = item._id;
            this.tableData.unshift(t);
          })
          this.tableData = this.tableData.splice(0,20);
          let len = 0;
          // 获取与上次不同的行数，也就是新的提醒的长度
          if(init){
            // 不是第一次登陆
            len = this.tableData.length;
          }
          else{
            for(let i = 0;i<this.tableData.length; i++){
              if(this.tableData[i]._id === this.formerTableData[0]._id){
                if(i==0&&this.tableData[0].f != this.formerTableData[0].f){
                  len = 1;
                }else{
                  len = i;
                }
                break;
              }
            }
          }
          let news = document.querySelectorAll('.el-table tbody tr');

          for(let i = 0;i<len;i++){
            news[i].style.opacity = "0";
            news[i].style.backgroundColor = "red";
            new Promise(resolve => {
              let index = 0;
              let opacities = [0,0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
              let anime = setInterval(()=>{
                news[i].style.opacity = opacities[index].toString();
                ++index;
                if(index === 10){
                  clearInterval(anime);
                  resolve();
                }
              }, 100)

            }).then(()=>{
              if(i % 2 === 0){
                setTimeout(()=>{
                  news[i].style.backgroundColor = "rgb(32,51,126)";
                 // setTimeout(()=>{
                 //    this.getScrollDevScreen(false);
                 //  },500);
                },500)
              }else{
                setTimeout(()=>{
                  news[i].style.backgroundColor = "rgb(35,78,182)";
                  // setTimeout(()=>{
                  //   this.getScrollDevScreen(false);
                  // },500);
                },500)
              }

            })
          }

          // for(let i = 0;i<len; i++){
          //
          //   news[i].style.backgroundColor = "red";
          //   if(i % 2 === 0){
          //     setTimeout(()=>{
          //       news[i].style.backgroundColor = "rgb(32,51,126)";
          //     },1000)
          //   }else{
          //     setTimeout(()=>{
          //       news[i].style.backgroundColor = "rgb(35,78,182)";
          //     },1000)
          //   }
          // }
        }else{
          this.$message({
            type:'error',
            message:'获取提醒失败，' + res.data.error.message
          })
        }
      })
    },
    tabRowClassName({row,rowIndex}){
      let index = rowIndex + 1;
      if(index %2 === 0){
        return 'warning-row'
      }
      else{
        return 'success-row';
      }
    },
    load (){
      this.count += 2;
    }
  },
  mounted(){
    this.getScrollDevScreen(true);
    this.interval = setInterval(()=>{
      this.getScrollDevScreen(false);
    }, 3000);
  },
  destroyed(){
    clearInterval(this.interval);
  },
  computed:{
    rowClass: function (row, index) {
      return {
        "height": "20px",
      }
    }
  }
}
</script>

<style scoped>

</style>
<style lang="scss">
  #rightThree{
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
      height: 30px;
      font-size: 12px;
      font-family: 黑体;
    }
    .el-table .warning-row{
      background:rgb(35,78,182);
    }
    .el-table .success-row {
      background: rgb(32,51,126);
    }

    .el-table__body tr,
    .el-table__body td {
      /*background-color: #20337e;*/
      padding: 0;
      height: 30px;
    }
    .el-table tbody tr >td{
      font-size: 12px;
      transform: scale(1);
    }
    .el-table tbody tr:hover>td {
      background-color:orangered!important
    }
    .el-table tbody tr:hover .beforeCircle {
      background-color:yellow!important
    }
    .el-table__row{
      font-size: 12px;
    }
    div.cell{
      color: white;
      font-weight: normal;
      padding: 0 0 0 5px  !important;
    }
    div.cell:before{
      width: 1px;
      height: 10px;
      background-color: green;
      z-index: 10;
    }
    tr.el-table__row > td{
      font-size: 12px;
      border-bottom: none !important;
    }
    #rightThreeContent::-webkit-scrollbar{ // Chrome去滚动条
      display: none;
    }
    #rightThreeContent{
      -ms-overflow-style: none; // IE 去滚动条
      scrollbar-width: none; // 火狐去滚动条
    }
  }
</style>
